import {
  SET_GROUPS,
  SET_GROUPS_ERROR,
  SET_ORGANIZATIONS,
  SET_ORGANIZATIONS_ERROR,
  SET_USERS,
  SET_USERS_ERROR,
} from '../../utils/constants/action-types';

const initalUsersState = {
  groups: [],
  groupsError: Error,
  organizations: [],
  organizationsError: Error,
  users: [],
  usersError: Error,
  error: null,
};

const reducer = (state = initalUsersState, action: any) => {
  switch (action.type) {
    case SET_GROUPS: {
      return { ...state, groups: action.payload };
    }
    case SET_GROUPS_ERROR: {
      return { ...state, groupsError: action.payload };
    }
    case SET_ORGANIZATIONS: {
      return { ...state, organizations: action.payload };
    }
    case SET_ORGANIZATIONS_ERROR: {
      return { ...state, organizationsError: action.payload };
    }
    case SET_USERS: {
      return { ...state, users: action.payload };
    }
    case SET_USERS_ERROR: {
      return { ...state, usersError: action.payload };
    }
    default: {
      return state;
    }
  }
};
export { reducer as UsersReducer };
